import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { 
  Shield, LayoutDashboard, ShieldAlert, ScrollText, Users, 
  LogOut, Server, Wifi, Activity, RefreshCw, Settings, Download, CreditCard, BrainCircuit 
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SubscriptionGuard from './SubscriptionGuard'; 
import logo from '../img/image-2026-05-21-08-52-40-636.png';

const AgentsPage = ({ onLogout }) => {
  const [agents, setAgents] = useState([]);
  const [stats, setStats] = useState({subscription_status: 'loading', agents_online: 0, uptime: '...' });
  const [loading, setLoading] = useState(false);
  const tenantId = localStorage.getItem('tenant_id');
  
  const navigate = useNavigate();
  const userRole = localStorage.getItem('role');


  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'X-NOC-Token': token } };

      const [resStats, resAgents] = await Promise.all([
        axios.get('https://ai-noc.skynix.co/api/stats', config),
        axios.get('https://ai-noc.skynix.co/api/agents', config)
      ]);
      setStats(resStats.data); 

      const data = Array.isArray(resAgents.data) ? resAgents.data : (resAgents.data.agents || []);
      setAgents(data);
    } catch (e) {
      console.error("Error fetching infrastructure data:", e);
      if (e.response?.status === 401) onLogout();
    }
    setTimeout(() => setLoading(false), 500);
  };
      


  useEffect(() => {
    fetchData();
    const t = setInterval(fetchData, 10000); 
    return () => clearInterval(t);
  }, []);

  return (
    <div className="d-flex" style={{ minHeight: '100vh', backgroundColor: '#0b0e14', color: '#e2e8f0' }}>
       <SubscriptionGuard data={stats} onLogout={onLogout} tenantId={tenantId}>
      
    <div className="sidebar" style={{ width: '64px', background: '#0d1117', borderRight: '1px solid #1e293b', height: '100vh', position: 'fixed', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '25px 0', zIndex: 1050 }}>
            <div
                      className="sidebar-item d-flex justify-content-center"
                      data-label="Go to Landing Page" 
                      onClick={() => window.location.href = 'https://noc.skynix.co'}
                      style={{
                        transform: 'translateY(-6px)',
                        marginBottom: '20px',
                        cursor: 'pointer' 
                      }}
                    >
                      <img
                        src={logo}
                        alt="SKYNIX"
                        style={{
                          width: '34px',
                          height: '34px',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
        
        <div className="sidebar-item"  data-label="Dashboard"  onClick={() => navigate('/')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}>
          <LayoutDashboard size={24} />
        </div>
        

        <div className="sidebar-item" data-label="Security Incidents" onClick={() => navigate('/incidents')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}>
          <ShieldAlert size={24} />
        </div>


        <div className="sidebar-item"  data-label="System Logs" onClick={() => navigate('/logs')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}>
          <ScrollText size={24} />
        </div>

        <div className="sidebar-item active" data-label="Infrastructure"  style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '10px', borderRadius: '8px', cursor: 'pointer', marginBottom: '30px' }}>
          <Server size={24} />
        </div>


        
        <div className="sidebar-item" data-label="User Management" onClick={() => navigate('/users')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Users size={24} /></div>
        

        <div className="sidebar-item" data-label="Billing & Plans" onClick={() => navigate('/subscription')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}>
            <CreditCard size={24} />
        </div>
        
        <div className="sidebar-item mt-auto mb-3"  data-label="Settings"
                  onClick={() => navigate('/settings')} 
                  style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '20px' }}>
                <Settings size={24} className={window.location.pathname === '/settings' ? 'text-info' : ''} />
              </div>
        
              <div className="sidebar-item mb-3" data-label="Logout" onClick={onLogout} style={{cursor: 'pointer'}}>
                <LogOut size={24} className="text-danger" />
              </div>
      </div>

      <div className="main-wrapper" style={{ marginLeft: '64px', width: 'calc(100% - 64px)' }}>
        
        
        <header className="soc-header" style={{ height: '60px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', background: '#0b0e14' }}>
          <div className="d-flex align-items-center gap-3">
                 
                <h5 
                  className="sidebar-item tooltip-bottom m-0 d-flex align-items-center"
                  data-label="Go to Landing Page"
                  onClick={() => window.location.href = 'https://noc.skynix.co'}
                  style={{ 
                    color: '#00f2ff', 
                    fontSize: '1.1rem', 
                    cursor: 'pointer',
                    lineHeight: '1',      
                    transform: 'translateY(1px)' 
                  }}
                >
                  SKYNIX <span className="text-white ms-2">AI-NOC</span>
                </h5>
            <div style={{ width: '1px', height: '24px', background: '#334155' }}></div>
            <div className="text-secondary small d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              <Activity size={16} className="text-info" /> Security Operations Center
            </div>
          </div>
          
          <div className="d-flex gap-4 align-items-center">
           <div style={{ 
                                          background: stats.subscription_status === 'active' 
                                            ? 'rgba(0, 242, 255, 0.1)' 
                                            : stats.subscription_status === 'loading' 
                                              ? 'rgba(148, 163, 184, 0.1)' 
                                              : 'rgba(239, 68, 68, 0.1)',  
                                          
                                          color: stats.subscription_status === 'active' 
                                            ? '#00f2ff' 
                                            : stats.subscription_status === 'loading' 
                                              ? '#94a3b8' 
                                              : '#ef4444', 
                                          
                                          padding: '4px 14px', 
                                          borderRadius: '20px', 
                                          fontSize: '0.8rem', 
                                          border: `1px solid ${
                                            stats.subscription_status === 'active' 
                                              ? '#00f2ff44' 
                                              : stats.subscription_status === 'loading' 
                                                ? '#94a3b844' 
                                                : '#ef444444'
                                          }`, 
                                          fontWeight: '600' 
                                        }}>
                                          {stats.subscription_status === 'loading' 
                                            ? 'Verifying license...' 
                                            : stats.subscription_status === 'active'
                                              ? `Plan: ${stats.plan_name} (${stats.agents_online}/${stats.max_servers})`
                                              : 'SUBSCRIPTION INACTIVE'
                                          }
                                        </div>
                                        <div className="header-metric small text-secondary">
                                      <BrainCircuit size={14} className="me-1" style={{ color: '#a855f7' }}/> AI Tokens: <b className={stats.ai_tokens_spent >= stats.ai_tokens_limit ? "text-danger" : "text-white"}>
                                          {stats.ai_tokens_spent?.toLocaleString() || 0} / {stats.ai_tokens_limit?.toLocaleString() || '1,000,000'}
                                      </b>
                                    </div>
            <div style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981', padding: '4px 14px', borderRadius: '20px', fontSize: '0.8rem', border: '1px solid #10b98144', fontWeight: '600' }}>
               Core: Healthy
            </div>
            <div className="header-metric small text-secondary">
               <Server size={14} className="me-1" style={{ color: '#00f2ff' }}/> Agents Online: <b className="text-white">{stats.agents_online}</b>
            </div>
            <div className="header-metric small text-secondary">
               <Wifi size={14} className="me-1" style={{ color: '#00f2ff' }}/> Uptime: <b className="text-white" style={{ color: '#00f2ff' }}>{stats.uptime}</b>
            </div>
          </div>
        </header>

       {stats.ai_tokens_spent >= stats.ai_tokens_limit && (
        <div className="alert bg-danger bg-opacity-10 border-danger text-danger d-flex align-items-center gap-3 m-4 py-3 shadow-lg" 
            style={{ borderRadius: '12px', border: '1px solid #ef4444' }}>
          <ShieldAlert size={24} />
          <div className="flex-grow-1">
            <div className="fw-bold">ATTENTION! AI TOKENS EXPIRED</div>
            <div className="small opacity-80">
              Your AI analysis quota is empty. Please 
              <b className="text-decoration-underline ms-1 pointer" style={{cursor: 'pointer'}} onClick={() => navigate('/subscription')}>upgrade your plan</b> 
              to continue using AI-NOC intelligent features.
            </div>
          </div>
          <button className="btn btn-danger btn-sm fw-bold px-3" onClick={() => navigate('/subscription')}>
            UPGRADE NOW
          </button>
        </div>
      )} 

        <div className="p-4">
          <div className="d-flex justify-content-between align-items-end mb-4">
            <div>
              <h2 className="fw-bold mb-1">Infrastructure</h2>
              <p className="text-secondary small m-0">Real-time health status of connected remote agents</p>
            </div>
            <div className="d-flex gap-2">
              <a href="/install" className="btn btn-outline-danger btn-sm fw-bold px-4 d-flex align-items-center gap-2">
                <Download size={14} /> 
                Install Agent
              </a>
              <button onClick={fetchData} className="btn btn-info btn-sm fw-bold px-4 d-flex align-items-center gap-2">
                <RefreshCw size={14} className={loading ? 'animate-spin' : ''} /> 
                {loading ? 'Updating...' : 'Refresh Status'}
              </button>
            </div>
          </div>

          
          <div className="noc-card p-0 overflow-hidden shadow-lg" style={{ background: '#151921', borderRadius: '12px', border: '1px solid #1e293b' }}>
            <table className="table-noc m-0 w-100" style={{ borderCollapse: 'collapse' }}>
              <thead style={{ background: 'rgba(0,0,0,0.2)' }}>
                <tr className="text-secondary small text-uppercase">
                  <th className="p-3 border-0">Node Status</th>
                  <th className="p-3 border-0">Hostname & Identifier</th>
                  <th className="p-3 border-0 text-end">Last Heartbeat</th>
                </tr>
              </thead>
              <tbody>
                {agents.length > 0 ? agents.map(agent => (
                  <tr key={agent.agent_id} style={{ borderBottom: '1px solid #1e293b' }}>
                    <td className="p-3">
                      <div className="d-flex align-items-center gap-2">
                        <span style={{ 
                          width: '8px', height: '8px', borderRadius: '50%', 
                          background: agent.status === 'online' ? '#10b981' : '#ef4444',
                          boxShadow: agent.status === 'online' ? '0 0 8px #10b981' : 'none'
                        }}></span>
                        <span className={agent.status === 'online' ? 'text-success' : 'text-danger'} style={{fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase'}}>
                          {agent.status}
                        </span>
                      </div>
                    </td>
                    <td className="p-3">
                      <div className="fw-bold text-white">{agent.host}</div>
                      <div className="text-secondary font-monospace" style={{ fontSize: '0.7rem' }}>{agent.agent_id}</div>
                    </td>
                    <td className="p-3 text-end">
                       <div className="text-white small fw-bold">{agent.last_seen}</div>
                       <div className="text-secondary" style={{fontSize: '0.65rem'}}>Kyiv Timezone</div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="3" className="text-center p-5 text-secondary">
                        <Server size={40} className="mb-2 opacity-20" />
                        <p>No agents detected in the database.</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </SubscriptionGuard>
    </div>
  );
};

export default AgentsPage;